<script lang="ts">
  import { activeTab, currentPage } from './lib/store.js';
  import { t, locale, setLocale } from './lib/i18n.js';
  import Encrypt from './components/Encrypt.svelte';
  import Decrypt from './components/Decrypt.svelte';
  import About from './components/About.svelte';
  import NotFound from './components/NotFound.svelte';

  let cardEl: HTMLElement | undefined = $state(undefined);

  function goto(page: 'app' | 'about', tab?: 'encrypt' | 'decrypt') {
    currentPage.set(page);
    if (tab) activeTab.set(tab);
    history.replaceState(null, '', page === 'about' ? '/about' : '/');
  }

  // Replay the fade-slide animation each time the visible tab changes.
  $effect(() => {
    void $activeTab;
    if (cardEl) {
      cardEl.style.animation = 'none';
      cardEl.offsetHeight; // force reflow to restart animation
      cardEl.style.animation = '';
    }
  });

  function toggleLocale() {
    setLocale($locale === 'nl' ? 'en' : 'nl');
  }

  if (typeof location !== 'undefined') {
    const p = location.pathname;
    if (p === '/about') currentPage.set('about');
    else if (p !== '/') currentPage.set('notfound');
    else currentPage.set('app');
  }
</script>

<div class="container">
  <div class="header">
    <div class="logo">T</div>
    <h1>TimeLock</h1>
    <button class="lang-toggle" onclick={toggleLocale}>
      {$locale === 'nl' ? 'EN' : 'NL'}
    </button>
  </div>

  <!-- Tabs + tab panels stay mounted so their $state persists across
       tab switches. Hidden rather than conditionally rendered. -->
  <div class="tabs" hidden={$currentPage !== 'app'}>
    <button class:active={$activeTab === 'encrypt'} onclick={() => goto('app', 'encrypt')}>{$t('tabs.encrypt')}</button>
    <button class:active={$activeTab === 'decrypt'} onclick={() => goto('app', 'decrypt')}>{$t('tabs.decrypt')}</button>
  </div>

  <div class="card tab-animated" bind:this={cardEl} hidden={$currentPage !== 'app'}>
    <div hidden={$activeTab !== 'encrypt'}><Encrypt /></div>
    <div hidden={$activeTab !== 'decrypt'}><Decrypt /></div>
  </div>

  {#if $currentPage === 'about'}
    <About onBack={() => goto('app')} />
  {/if}

  {#if $currentPage === 'notfound'}
    <NotFound onBack={() => goto('app')} />
  {/if}

  <div class="footer">
    <a href="/about" onclick={(e) => { e.preventDefault(); goto('about'); }}>
      {$t('footer.link')}
    </a>
  </div>
</div>
